import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/HomePage/GeneralSection.styl'
import JoinButton from 'components/features/pfm/JoinButton/JoinButton'
import { createResponsiveImgProps } from 'helpers/viewportHelpers'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'

const HERO_IMAGE_EXT = 'jpg'
const MOBILE_HERO_IMAGE = '/images/homepage/iphone-mobile'
const DESKTOP_HERO_IMAGE = '/images/homepage/iphone-desktop'

const GeneralSection: FC = () => {
  const mobileImage = (
    <img
      className={ cn(styles.image, styles.mobileImage) }
      { ...createResponsiveImgProps(`${ MOBILE_HERO_IMAGE }.${ HERO_IMAGE_EXT }`) }
    />
  )

  const padSrcset = [
    `${ MOBILE_HERO_IMAGE }@2x.jpg 1020w`,
    `${ MOBILE_HERO_IMAGE }@3x.jpg 2040w`,
  ]

  const padImage = (
    <img
      className={ cn(styles.image, styles.padImage) }
      srcSet={ padSrcset.join(', ') }
      sizes='130vw'
    />
  )

  const desktopImage = (
    <img
      className={ cn(styles.image, styles.desktopImage) }
      { ...createResponsiveImgProps(`${ DESKTOP_HERO_IMAGE }.${ HERO_IMAGE_EXT }`) }
    />
  )

  return (
    <section className={ styles.generalSection }>
      <div className={ styles.contentWrapper }>
        <h1 className={ styles.headline }>
          Compare Finances
          <br />
          with Peers
        </h1>
        <p className={ styles.summary }>
          Visualize your finances like never before. Make smarter choices with our free suite of financial tools and expert advice. Stay motivated by earning rewards while improving your status.
        </p>
        <AnalyticsClick
          className={ styles.buttonWrapper }
          category='page_controls-homepage'
          action='click-join_cta'
          label='general_section'
        >
          <JoinButton
            shadow='heavy'
            fullHeight
            fullWidth
          />
          <div className={ styles.userCounter }>
            400,000+ members
          </div>
        </AnalyticsClick>
      </div>
      { mobileImage }
      { padImage }
      { desktopImage }
    </section>
  )
}

export default GeneralSection
